module.exports = __webpack_public_path__ + "static/itsm_capabilities_12-ab192ef49829350d665751096087af57.png";